// Renders children as-is without wrapper element
const RenderChildren = props => props.children
export default RenderChildren
